import { render } from "./CreateRelocation.vue?vue&type=template&id=bf6b6b18&scoped=true&ts=true"
import script from "./CreateRelocation.vue?vue&type=script&lang=ts"
export * from "./CreateRelocation.vue?vue&type=script&lang=ts"

import "./CreateRelocation.vue?vue&type=style&index=0&id=bf6b6b18&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6b6b18"]])

export default __exports__